import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class CertificationProvidersStateModel extends PaginatedSubentityStateModel {
    static identifier = 'AssassmentSectionsStateModel';
    userIds: number[];

    constructor() {
        super(CertificationProvidersStateModel.identifier);
    }
}
